import { render, staticRenderFns } from "./NewPersonnelModal.vue?vue&type=template&id=c0ce4cc0&"
import script from "./NewPersonnelModal.vue?vue&type=script&lang=js&"
export * from "./NewPersonnelModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports